module.exports = __webpack_public_path__ + "static/27-img-1-30247b870bb3ba279bb78091e29cd684.jpg";